
/* eslint-disable */
/**
 * OneTrust Cookies Consent
 * 
 */
import { ParamsData } from '../app';

function Onetrust() {
    const id = ParamsData.onetrust_id;

    let script = document.createElement('script');
    script.src = `https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`;
    script.setAttribute('data-domain-script', id);
    document.head.appendChild(script);


    window.OptanonWrapper = () => {
        const cookie_cats = window.OnetrustActiveGroups;

        //Necessary
        if (!!cookie_cats.includes('C0001')) {
            console.log("Necessary cookie enabled");
        }

        //Performance
        if (!!cookie_cats.includes('C0002')) {
            console.log("Performance cookie enabled");
        }

        //Functional 
        if (!!cookie_cats.includes('C0003')) {
            console.log("Functional cookie enabled");

            if (ParamsData.gtag_key) {
                const script = document.createElement("script");
                script.src = `https://www.googletagmanager.com/gtag/js?id=${ParamsData.gtag_key}`;
                script.setAttribute("async", "");

                document.querySelector("head").appendChild(script);

                window.dataLayer = window.dataLayer || [];

                function gtag() {
                    dataLayer.push(arguments);
                }

                gtag("js", new Date());

                gtag("config", `${ParamsData.gtag_key}`);
            }
        }

        //Targeting
        if (!!cookie_cats.includes('C0004')) {
            console.log("Targeting cookie enabled");
        }

        //Social
        if (!!cookie_cats.includes('C0005')) {
            console.log("Social cookie enabled");
        }
    }
};

export { Onetrust };
